import { render, staticRenderFns } from "./SubscriptionPlanList.vue?vue&type=template&id=7989c32d&scoped=true"
import script from "./SubscriptionPlanList.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlanList.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPlanList.vue?vue&type=style&index=0&id=7989c32d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7989c32d",
  null
  
)

export default component.exports